// Card images fade in over the card's neutral-100 placeholder instead of
// popping as they lazy-load. JS-additive: is-loading is only ever set here,
// so without JS images render normally. Eager images (above the fold /
// fetchpriority=high) are skipped — hiding them would delay LCP paint.
// A MutationObserver covers AJAX-swapped cards (discover filters, load-more,
// home strips).
(function () {
  const SELECTOR = 'img.ds-event-card__image-media[loading="lazy"]';

  function bind(img) {
    if (img.dataset.fadeBound === 'true') return;
    img.dataset.fadeBound = 'true';
    if (img.complete) return; // already painted (cache) — nothing to fade
    img.classList.add('is-loading');
    const reveal = () => img.classList.remove('is-loading');
    img.addEventListener('load', reveal, { once: true });
    img.addEventListener('error', reveal, { once: true });
  }

  function scan(root) {
    if (root.matches && root.matches(SELECTOR)) bind(root);
    if (root.querySelectorAll) root.querySelectorAll(SELECTOR).forEach(bind);
  }

  function init() {
    scan(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
